export enum AvailabilityType {
  Direct = 'Direct',
  Sublet = 'Sublet',
}
